import { addMinutes } from "date-fns";
import { EventColor, EventResponseStatus, PrimaryCategory } from "../reclaim-api/EventMetaTypes";
import { Event, EventKey, EventStatus, ReclaimEventType } from "../reclaim-api/Events";
import { Recurrence } from "../reclaim-api/OneOnOnes.types";
import { AssignmentOrEventType } from "../types";
import { roundTimeToNextChunk } from "./dates";

export function parseEventKey(eventKey: EventKey): { eventId: string; calendarId: number } {
  const [, calendarIdStr, eventId] = eventKey.match(/^(\d+)\/(.+)$/) || [];
  const calendarId = parseInt(calendarIdStr);
  if (!calendarIdStr || isNaN(calendarId) || !eventId) throw new Error(`Invalid eventKey format: ${eventKey}`);
  return { calendarId, eventId };
}

export function getEffectiveRecurrence(recurrence?: Recurrence | null, timesPerPeriod?: number): Recurrence {
  if (!recurrence) {
    if (timesPerPeriod === 7) return Recurrence.Daily;
    else return Recurrence.Weekly;
  }

  return recurrence;
}

export const getAssignmentIdAndType = (
  event: Event
): { assignmentId: number | string; type: AssignmentOrEventType } => {
  if (!!event.assist?.dailyHabitId) {
    if (event?.reclaimEventType === ReclaimEventType.OneOnOneAssignment) {
      return { assignmentId: event.assist?.dailyHabitId, type: "one-on-one" };
    } else {
      return { assignmentId: event.assist.dailyHabitId, type: "habit" };
    }
  } else if (event.reclaimEventType === ReclaimEventType.SchedulingLinkAssignment) {
    return { assignmentId: event.schedulingLinkMeetingId as string, type: "scheduling-link" };
  } else if (!!event?.assist?.taskId) {
    return { assignmentId: event.assist.taskId, type: "task" };
  } else {
    return { assignmentId: event.key, type: "event" };
  }
};

export const getUpcomingFakeEvent = (title: string, color: EventColor): Event => ({
  title,
  color,
  eventStart: roundTimeToNextChunk(new Date()),
  eventEnd: addMinutes(roundTimeToNextChunk(new Date()), 60),
  rsvpStatus: EventResponseStatus.Accepted,
  status: EventStatus.Published,
  key: "fakeKey",
  reclaimEventType: ReclaimEventType.Sync,
  category: PrimaryCategory.ExternalMeeting,
  eventId: "fakeEventId",
});
